module.exports = __webpack_public_path__ + "img/text.7e093196.png";